angular.module('cfn').controller('bookingActivitiesPopupController', [
  '$scope',
  '$rootScope',
  '$location',
  '$log',
  'bookingActivitiesService',
  'bookingRenderService',
  function(
    $scope,
    $rootScope,
    $location,
    $log,
    bookingActivitiesService,
    bookingRenderService
  ) {
    $scope.activityIconRenderer = bookingRenderService.activityIconRenderer;
    $scope.listData = [];

    $scope.delete = function() {
      $scope.listData.forEach(function(item) {
        if (item.$cfngrid_selected === true) {
          bookingActivitiesService.del(item.id).then(function() {
            bookingActivitiesService.query().then(function(result) {
              $scope.listData = result;
            });
          });
        }
      });
    };

    $scope.isSelected = function() {
      return $scope.listData.some(function(item) {
        return item.$cfngrid_selected === true;
      });
    };

    $scope.insert = function() {
      $location.path('/booking/activity');
    };

    $scope.edit = function() {
      $location.path('/booking/activity/' + $scope.getSelected().id);
    };

    $scope.close = function() {
      ang.callInParents($scope, 'closePopover')();
    };

    $scope.cellDblClick = function(rowData, rowIndex, args) {
      $scope.selected();
    };

    $scope.getSelected = function() {
      for (var i = 0; i < $scope.listData.length; i++) {
        if ($scope.listData[i].$cfngrid_selected) return $scope.listData[i];
      }
      return null;
    };

    $scope.onShow = function(scope, tooltip) {
      $scope.listData = [];
      bookingActivitiesService.query().then(function(result) {
        $scope.listData = result;
      });
    };

    // register onShow in popover component. This is not the angular way of doing it.TODO: find a better way if possible (ASG)
    ang.callInParents($scope, 'registerShowTooltipHandler')($scope.onShow);
    return ($scope.bookingActivitiesPopupController = this);
  }
]);
